<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <!-- Pertanyaan -->
              <b-form-group
                label="Pertanyaan"
                label-for="v-question"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Pertanyaan"
                  rules="required"
                >
                  <quill-editor
                    id="v-question"
                    v-model="form.question"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Jawaban -->
              <b-form-group
                label="Jawaban"
                label-for="v-answer"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jawaban"
                  rules="required"
                >
                  <quill-editor
                    id="v-answer"
                    v-model="form.answer"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Kategori -->
              <b-form-group
                label="Kategori FAQ"
                label-for="v-category"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kategori FAQ"
                  rules="required"
                >
                  <v-select
                    v-model="selectedCategory"
                    label="name"
                    :options="faqCategories.data"
                  >
                    <template #no-options="">
                      Kategori FAQ.
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label-for="v-is_active"
              >
                <b-form-checkbox
                  v-model="form.is_active"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Aktif
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                label-for="v-is_highlighted"
              >
                <b-form-checkbox
                  v-model="form.is_highlighted"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Highlight
                </b-form-checkbox>
              </b-form-group>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  mapActions,
  //   mapGetters,
  mapState,
} from 'vuex'

import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  //   BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'

// Vee Validate
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import { required, integer, minValue } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    quillEditor,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        question: '',
        answer: '',
        is_active: true,
        is_highlighted: false,
      },
      urlPreview: '',
      selectedCategory: null,
      required,
      minValue,
      integer,
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('faqCategory', ['faqCategories']),
    ...mapState('faq', ['faq']),
    faqId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    await this.getCategoriesFaq()

    if (this.isEdit) {
      await this.getFaq({ id: this.faqId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('faqCategory', ['getCategoriesFaq']),
    ...mapActions('faq', ['createFaq', 'getFaq', 'updateFaq']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      if (this.selectedCategory) {
        this.form.faq_category_id = this.selectedCategory.id
      }

      if (!this.isEdit) {
        await this.createFaq(this.form)
      } else {
        await this.updateFaq({ faqId: this.faqId, data: this.form })
      }

      this.isSubmitting = false
      this.$router.push('/faq')
    },
    // Edit State Only
    fillData() {
      this.form.question = this.faq.data.question
      this.form.answer = this.faq.data.answer
      this.form.is_active = !!this.faq.data.is_active
      this.form.is_highlighted = !!this.faq.data.is_highlighted

      if (this.faq.data.category) {
        const category = this.faqCategories.data.find(c => c.id === this.faq.data.category.id)
        this.selectedCategory = category
      }
    },
  },
}
</script>

<style lang="scss">
.image-preview {
    width: 102px;
    height: 102px;
    background-color: white;
    border: 1px solid red;
    position: relative;
    img {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
